export default __webpack_public_path__ + "static/media/img_step_hami02.488a1140.png";